/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserListResponse = {
  type: 'all-of',
  contains: [{
    type: 'ListResponse',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'User',
        },
      },
    },
  }],
} as const;
